import { useEffect } from "react";
import { fakeToken } from "@/views/login/Model.ts";

const Login = () => {
  useEffect(() => {
    if (!localStorage.getItem("LOGIN_INFO")) {
      localStorage.setItem("LOGIN_INFO", JSON.stringify(fakeToken));
    }
  }, []);
  return <div>Day la trang login</div>;
};

export default Login;
